import { render, staticRenderFns } from "./DxBpas.vue?vue&type=template&id=5ba68d9a&scoped=true&"
import script from "./DxBpas.vue?vue&type=script&lang=js&"
export * from "./DxBpas.vue?vue&type=script&lang=js&"
import style0 from "./DxBpas.vue?vue&type=style&index=0&id=5ba68d9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba68d9a",
  null
  
)

export default component.exports